/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Columnmenu_Clearsort2Inputs */

const en_columnmenu_clearsort2 = /** @type {(inputs: Columnmenu_Clearsort2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear Sort`)
};

const de_columnmenu_clearsort2 = /** @type {(inputs: Columnmenu_Clearsort2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sortierung löschen`)
};

/**
* | output |
* | --- |
* | "Clear Sort" |
*
* @param {Columnmenu_Clearsort2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const columnmenu_clearsort2 = /** @type {((inputs?: Columnmenu_Clearsort2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Columnmenu_Clearsort2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_columnmenu_clearsort2(inputs)
	return de_columnmenu_clearsort2(inputs)
});
export { columnmenu_clearsort2 as "columnMenu_clearSort" }